/** * @file RequiredText * 「必須」を表示するテキスト */
<template>
  <span class="require">必須</span>
</template>

<script>
export default {}
</script>
